import React, { useState } from 'react';
import {
  CardBody,
  CardHeader,
  Row,
  Card,
  Col,
  CardTitle,
  Form,
  FormGroup,
  Input,
  Button,
} from 'reactstrap';
import { useForm } from 'hooks/useForm';

interface FormValues {
  currentPassword: string;
  newPassword: string;
  rePassword: string;
}
import { useAlert } from 'hooks/useAlert';
import AlertModal from 'components/AlertModal';
import { changePassword } from 'features/matriculates/matriculatesAPI';

export default function ChangePassword() {
  const [values, handleChange] = useForm<FormValues>({
    currentPassword: '',
    newPassword: '',
    rePassword: '',
  });

  const [showAlert, message, alert] = useAlert(false, '');

  const { currentPassword, newPassword, rePassword } = values;

  const [isLoading, setIsLoading] = useState(false);

  const submit = async () => {
    try {
      setIsLoading(true);

      if (currentPassword === newPassword) {
        alert(true, 'La nueva contraseña no puede ser igual a la actual');
        return;
      }

      if (newPassword !== rePassword) {
        alert(true, 'Las contraseñas no coinciden');
        return;
      }

      if (newPassword.length < 6) {
        alert(true, 'La nueva contraseña debe tener al menos 6 caracteres');
        return;
      }

      const result = await changePassword(newPassword);

      if (result) {
        alert(true, 'Contraseña cambiada exitosamente');
      } else {
        alert(true, 'Se produjo un error al intentar cambiar la contraseña');
      }
    } catch (err) {
      console.error(err);
      alert(true, 'Se produjo un error al intentar cambiar la contraseña');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='content'>
      <AlertModal
        isOpen={showAlert}
        message={message}
        onClose={() => alert(false)}
      />
      <Row>
        <Col>
          <Card className='card-user'>
            <CardHeader>
              <Row>
                <Col sm={12}>
                  <CardTitle tag='h4'>Cambiar Contraseña</CardTitle>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <div className="text-center text-muted mb-5">
                <h3>Cambiar contraseña</h3>
              </div>
              <Form role="form">
                <FormGroup className="mb-3">
                  <Input
                    placeholder="Contraseña actual"
                    name='currentPassword'
                    type="password"
                    value={ currentPassword }
                    onChange={ handleChange }
                    disabled={ isLoading }
                  />
                </FormGroup>
                <FormGroup className="mb-3">
                  <Input
                    placeholder="Nueva contraseña"
                    name="newPassword"
                    type="password"
                    value={ newPassword }
                    onChange={ handleChange }
                    disabled={ isLoading }
                  />
                </FormGroup>
                <FormGroup>
                  <Input
                    placeholder="Repita nueva contraseña"
                    name="rePassword"
                    type="password"
                    value={ rePassword }
                    onChange={ handleChange }
                    disabled={ isLoading }
                  />
                </FormGroup>
                <div className="text-center">
                  <Button
                    className="my-4"
                    color="primary"
                    type="button"
                    onClick={ submit }
                    disabled={ isLoading }
                  >
                    Cambiar contraseña
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
